function RequiredField() {
  return <span className="text-red-600 font-bold">*</span>;
}
export default RequiredField;
